import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IGetVenueResponseBody, IGetVenueResponseData } from './types';

export const getVenue = async (venueId: string): Promise<IGetVenueResponseData> => {
  try {
    const res = await fetch(`${API_URL}/venues/${venueId}`);

    if (!res.ok) throw new Error();

    const { data }: IGetVenueResponseBody = await res.json();
    return data[0];
  } catch (e) {
    throw new Error('Could not fetch venue');
  }
};
